import {useHistory} from "react-router";
import {useLocation} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import * as S from './styles'

import AndroidImage from '../../assets/images/dwl_android.png';
import AndroidImageDark from '../../assets/images/dwl_android_dark.png';
import IphoneImage from '../../assets/images/dwl_iphone.png';
import IphoneImageDark from '../../assets/images/dwl_iphone_dark.png';
import ApkImage from '../../assets/images/dwl_apk.png'
import ApkImageDark from '../../assets/images/dwl_apk_dark.png'
import WindowsImage from '../../assets/images/dwl_windows.png'
import WindowsImageDark from '../../assets/images/dwl_windows_dark.png'
import LinuxImage from '../../assets/images/dwl_linux.png'
import LinuxImageDark from '../../assets/images/dwl_linux_dark.png'
import MacImage from '../../assets/images/dwl_mac.png'
import MacImageDark from '../../assets/images/dwl_mac_dark.png'
import {useStores} from "../../hooks/useStores";

type CardInfo = {
    imagePath: string
    imagePathDark: string
    title: string
    text: string
    link: string
    outer: boolean
}

const cards: CardInfo[] = [
    {
        imagePath: AndroidImage,
        imagePathDark: AndroidImageDark,
        title: 'Android',
        text: 'downloadCardAndroidText',
        link: 'http://play.google.com/store/apps/details?id=ch.swisscows.messenger.teleguardapp',
        outer: true
    },
    {
        imagePath: IphoneImage,
        imagePathDark: IphoneImageDark,
        title: 'iPhone и iPad',
        text: 'downloadCardIPhoneText',
        link: 'https://apps.apple.com/ru/app/teleguard/id1505636751',
        outer: true
    },
    {
        imagePath: ApkImage,
        imagePathDark: ApkImageDark,
        title: 'APK-file',
        text: 'downloadCardApkText',
        link: '/apk',
        outer: false
    },
    {
        imagePath: WindowsImage,
        imagePathDark: WindowsImageDark,
        title: 'Windows',
        text: 'downloadCardWindowsText',
        link: '/windows',
        outer: false
    },
    {
        imagePath: LinuxImage,
        imagePathDark: LinuxImageDark,
        title: 'Linux',
        text: 'downloadCardLinuxText',
        link: '/linux',
        outer: false
    },
    {
        imagePath: MacImage,
        imagePathDark: MacImageDark,
        title: 'MacOS',
        text: 'downloadCardMacText',
        link: '/mac',
        outer: false
    }
]

export const Download = () => {
    const {uiStore} = useStores();
    const location = useLocation();
    const history = useHistory();
    const handleClick = (data: CardInfo) => () => {
        if (data.outer) {
            window.open(data.link, '_blank')
        } else {
            history.push(location.pathname.concat(data.link));
        }
    }

    return (
        <S.Container>
            <S.Title><FormattedMessage id="downloadTitle"/></S.Title>
            <S.Text>
                <FormattedMessage id="downloadText1"/>
            </S.Text>
            <S.Cards>
                {
                    cards.map(data =>
                        <S.Card key={data.title} onClick={handleClick(data)}>
                            <S.CardImageBlock>
                                <S.CardImage src={uiStore.isLightTheme ? data.imagePath : data.imagePathDark} alt={data.title}/>
                                <S.CardDownloadButton><FormattedMessage id="downloadCardDownloadButton"/></S.CardDownloadButton>
                            </S.CardImageBlock>
                            <S.CardContainer>
                                <S.CardTitle>{data.title}</S.CardTitle>
                                <S.CardText><FormattedMessage id={data.text}/></S.CardText>
                            </S.CardContainer>
                        </S.Card>
                    )
                }
            </S.Cards>
        </S.Container>
    )
}